import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { Icon, Link } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

type Props = HasProduct;

export interface ProductDetailsP65Styles {
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    titleText?: TypographyProps;
    informationalText?: TypographyProps;
    link?: LinkPresentationProps;
    warningIcon?: IconPresentationProps;
}

export const statusStyles: ProductDetailsP65Styles = {
    wrapper: {
        css: css`
            background-color: ${getColor("common.border")};
            border-radius: 5px;
        `,
    },
    titleWrapper: {
        css: css`
            display: inline-block;
            width: 100%;
            text-align: center;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            font-size: 12px;
            color: ${getColor("secondary")};
            display: inline;
            padding-right: 5px;
        `,
    },
    informationalText: {
        variant: "p",
        css: css`
            @media print {
                font-size: 12px;
            }
            padding: 10px;
            font-size: 12px;
            margin-bottom: 0;
        `,
    },
    link: {
        css: css`
            font-weight: 600;
            display: inline;
            span {
                vertical-align: unset;
            }
        `,
    },
    warningIcon: {
        src: "AlertTriangle",
        color: "secondary",
        size: 16,
        css: css`
            vertical-align: middle;
        `,
    },
};

const styles = statusStyles;

const ProductDetailsP65: React.FC<Props> = ({ product }) => {
    if (!product || !product.properties["prop65"]) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.titleText}>WARNING</Typography>
                <Icon {...styles.warningIcon}></Icon>
            </StyledWrapper>
            <Typography
                {...styles.informationalText}
                aria-labelledby="productDetailsProp65"
                data-test-selector="productDetailsProp65"
            >
                This product can expose you to chemicals, including {product.properties["prop65"]}, which are known to
                the state of California to cause cancer and birth defects or other reproductive harm. For more
                information visit{" "}
                <Link {...styles.link} href="http://www.P65Warnings.ca.gov">
                    www.P65Warnings.ca.gov
                </Link>
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsP65),
    definition: {
        displayName: "Prop 65 Warning",
        allowedContexts: ["ProductDetailsPage"],
        group: "Product Details",
    },
};

export default widgetModule;
